export const OM_ORDER_MODIFICATION_SLICE_NAME = 'om_modification';
